import React from "react";
import { graphql, useStaticQuery, Link } from 'gatsby';

import Avatar from '../Avatar';
import Skills from '../Skills';
import TextReveal from '../TextReveal';

import './style.css';

const Header = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            skills
          }
        }
      }
    `,
  );

  return (
    <header>
      <div className="flex-header-container">
        <div>
          <Avatar />
        </div>
        <div className="me">
          <h1 className="vt323-regular" title={site.siteMetadata.title}>
            <TextReveal
              text={site.siteMetadata.title}
              interval={100}
              repeatInterval={6000}
            />
          </h1>
        </div>
      </div>
      <Skills />
      <nav className="main-nav">
        <ul>
          <li><Link to="/" activeClassName="active">I'm</Link></li>
          <li><Link to="/projects" activeClassName="active">Passionate</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
